import { render, staticRenderFns } from "./ArrestTable.vue?vue&type=template&id=1a3102a4&scoped=true&"
import script from "./ArrestTable.vue?vue&type=script&lang=ts&"
export * from "./ArrestTable.vue?vue&type=script&lang=ts&"
import style0 from "./ArrestTable.vue?vue&type=style&index=0&id=1a3102a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3102a4",
  null
  
)

export default component.exports